<template>
  <div>
    <div class="search-form">
      <div class="search-form-right">
        <TableActions
          :actions="addActions"
          @add="addProductLine"
        />
      </div>
    </div>
    <div class="table">
      <a-table
        :columns="columns"
        :data-source="dataSource"
        :loading="loading"
        style="padding: 16px 0; background-color: #fff;"
        :row-key="(item, index) => index"
      >
        <span
          slot="actions"
          slot-scope="text, record"
        >
          <TableActions
            :actions="tableActions"
            :record="record"
            @edit="editProduct(record)"
            @delete="deleteRecord(record)"
          />
        </span>
      </a-table>
    </div>
    <EditProduct
      :init-data="initData"
      :dialog-title="dialogTitle"
      :visible="modalVisible"
      :loading="confirmLoading"
      :product-typetions="productTypetions"
      :action-type="actionType"
      @cancel="handleCancel"
      @ok="handleOk"
    />
  </div>
</template>

<script>
import { queryProductLine, deleteProductLine } from '@/api/productLine.js'
import EditProduct from './EditProductType.vue'

const columns = [
  {
    title: '产品线名称',
    dataIndex: 'productLineName',
    key: 'productLineName'
  },
  {
    title: '产品类型',
    dataIndex: 'productTypesName',
    key: 'productTypesName'
  },
  {
    title: '操作',
    dataIndex: 'actions',
    key: 'actions',
    width: '250px',
    scopedSlots: { customRender: 'actions' }
  }
]
const addActions = [{
  title: '添加产品线',
  type: 'primary',
  action: 'add',
  apis: ['@baseInfo/Add_Base']
}]

const tableActions = [
  {
    title: '编辑',
    type: 'link',
    action: 'edit',
    apis: ['@baseInfo/Add_Base']
  },
  {
    title: '删除',
    type: 'link',
    action: 'delete',
    apis: ['@baseInfo/Add_Base']
  }
]
export default {
  components: {
    EditProduct
    // CheckChangeRecords
  },
  data () {
    return {
      columns,
      dataSource: [],
      innerDataSource: [],
      loading: false,
      baseId: 0,
      subsidyTypes: [],
      productTypetions: [],
      tableActions,
      addActions,
      modalVisible: false,
      confirmLoading: false,
      initData: null,
      initRecords: null,
      dialogTitle: null,
      form: {
        productTypeId: undefined,
        subsidyType: undefined
      },
      actionType: null
    }
  },
  created () {
    this.loading = true
    this.fetchData()
  },
  methods: {
    // 异步获取数据
    async fetchData () {
      this.loading = true
      await queryProductLine({
      }).then((data) => {
        this.dataSource = data || []
      })
      this.loading = false
    },
    editProduct (record) {
      this.initData = record
      this.dialogTitle = '编辑产品线'
      this.modalVisible = true
      this.actionType = '0'
    },
    addProductLine () {
      this.initData = {
        productLineName: undefined,
        productTypeIds: []
      }
      this.modalVisible = true
      this.dialogTitle = '添加产品线'
      this.actionType = '1'
    },
    deleteRecord (record) {
      this.$confirm({
        title: '确定删除该条记录吗？',
        okText: '确认删除',
        cancelText: '取消',
        onOk: async () => {
          await deleteProductLine({
            productLineId: record.productLineId
          }).then((data) => {
            if (data) {
              this.$message.success('删除成功!')
              this.fetchData()
            }
          })
        }
      })
    },
    handleCancel () {
      this.modalVisible = false
    },
    handleOk () {
      this.handleCancel()
      this.fetchData()
    },
    handleChange (value) {
      this.form.time = value
    }
  }

}
</script>

<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 16px;
}

.search-form-right {
  margin-left: auto;
  margin-right: 200px;
}

/deep/.ant-table-body {
  width: 1200px;
  margin: auto;
}
</style>
